import React from 'react';
import DraggableWindow from './DraggableWindow';
import PosicaoEstoques from '../../pages/PosicaoEstoques';

const WindowPosicaoEstoques = ({
  isOpen,
  onClose,
  onMinimize,
  zIndex,
  onFocus,
  userData,
}) => {
  if (!isOpen) return null;

  return (
    <DraggableWindow
      title="Posição de Estoques"
      icon="fa-boxes-stacked"
      onClose={onClose}
      onMinimize={onMinimize}
      zIndex={zIndex}
      onFocus={onFocus}
      className="posicao-estoques-window"
      initialWidth={1200}
      initialHeight={720}
      initialTop={40}
      initialLeft={60}
    >
      <div className="window-posicao-estoques-wrapper">
        <PosicaoEstoques userData={userData} />
      </div>
    </DraggableWindow>
  );
};

export default WindowPosicaoEstoques;
